import { Component, OnInit, Inject, Optional, EventEmitter } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CommonService } from '../../../../services/common.service';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ProfileService } from '../../../../services/profile.service';

@Component({
  selector: 'new-protocol',
  templateUrl: './new-protocol.component.html',
  styleUrls: ['./new-protocol.component.scss']
})
export class NewProtocolComponent implements OnInit {
  loading: any;
  services: any;
  subServices: any;
  formProtocol: UntypedFormGroup;
  onUpdate = new EventEmitter();

  constructor(public dialogRef: MatDialogRef<NewProtocolComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private commonService: CommonService,
    private formBuilder: UntypedFormBuilder,
    private profileService: ProfileService
  ) {
    dialogRef.disableClose = true;
  }

  ngOnInit() {
    this.formProtocol = this.formBuilder.group({
      serviceType: ['', [Validators.required]],
      subServiceType: ['', [Validators.required]],
      protocolDescription: ['', [Validators.required]],
    });
    this.getServices();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  getServices() {
    if (this.commonService.getServices()) {
      this.services = this.commonService.getServices();
    } else {
      this.loading = true;
      this.commonService.getServiceTypes().subscribe(response => {
        this.loading = false;
        this.services = response.body;
        this.commonService.setServices(response.body);
      }, (error) => {
        this.loading = false;
        console.error('NewProtocolComponent_getServices', error);
      });
    }
  }

  getSubServices(service) {
    this.loading = true;
    this.commonService.getSubServiceTypes(service.value).subscribe((response) => {
      this.loading = false;
      this.subServices = response.body;
    }, (error) => {
      this.loading = false;
      console.error('NewProtocolComponent_getSubServices', error);
    });
  }

  saveProtocol() {
    let serviceType = this.formProtocol.get('serviceType').value;
    let subServiceType = this.formProtocol.get('subServiceType').value;
    let protocolDescription = this.formProtocol.get('protocolDescription').value;

    let data = {
      'customerKey': sessionStorage.getItem('legacyCustomerKeyId'),
      'pSDlServiceTypeKey': serviceType,
      'pSDLSSiSubServiceKey': subServiceType,
      'pSDtextProtocolDetails': protocolDescription,
      'isEdit': 0,
      'pSDbDisable': 0,
      'pSDlKey': 0
    }

    this.loading = true;
    this.profileService.addProtocols(data).subscribe(res => {
      this.loading = false;
      this.dialogRef.close();
      this.onUpdate.emit();
    });
  }

}
